import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

function Row({ border, startAligned, endAligned, to, styles: customStyles, children }) {
  const RowComponent = to ? Link : 'div';
  return (
    <RowComponent
      className={classnames([
        styles.row,
        {
          [styles.border]: border,
          [styles.startAligned]: startAligned,
          [styles.endAligned]: endAligned
        },
        ...customStyles
      ])}
      to={to}>
      {children}
    </RowComponent>
  );
}

Row.propTypes = {
  border: PropTypes.bool,
  startAligned: PropTypes.bool,
  endAligned: PropTypes.bool,
  to: PropTypes.string,
  styles: PropTypes.array,
  children: PropTypes.any
};

Row.defaultProps = {
  border: false,
  startAligned: false,
  endAligned: false,
  to: undefined,
  styles: [],
  children: null
};

export default Row;
